export default "__VITE_ASSET__g_XN$bgd__"